export const ALL_ROOM_REQUEST = "ALL_ROOM_REQUEST"
export const ALL_ROOM_SUCCESS = "ALL_ROOM_SUCCESS"
export const ALL_ROOM_FAIL = "ALL_ROOM_FAIL"
export const CLEAR_ERRORS = "CLEAR_ERRORS"